<template>
  <el-dialog
      direction="rtl"
      size="80%"
      class="global-dialog"
      destroy-on-close
      :show-close="false"
      :close-on-click-modal="false"
      :title="Lang.Title.dimensionLinkDevice"
      width="796px"
      v-model="selectDeviceDialog"
    >
    <template #header>
      <header v-if="title" style="margin-bottom: 22px;">
        <span class="dialog-title" style="font-family: Inter; font-size: 22px; font-weight: 600;">{{ title }}</span>
      </header>
      <div style="width: 80%;margin: 10px; display: flex; align-items: center;">
        <CompSearch 
          style="width: 50%;"
          :placeholder="Lang.Text.dimensionSearchDeviceName"
          v-model="search.nameOrSn"
          @change=" (val) => { this.onLoad(this.page, {nameOrSn: val }) }"
          >
        </CompSearch>
        <el-tooltip placement="top" v-if="tooltipText" >
          <template #content>
            <div class="pv-tooltip-box">
              {{ tooltipText }}
            </div>
          </template>
          <div style="font-size: 12px; color: #BAC0CC; margin-left: 10px;cursor: pointer;">
            <i class="icon-Tips" style="font-size: 14px; color: #616D7C;cursor: pointer;"></i>
          </div>
        </el-tooltip>
      </div>
    </template>
    <CompTable
      class="global-table"
      :data="data"
      :columns="column"
      :total="page.total"
      :page="page.currentPage"
      :page-size="page.pageSize"
      header-bg-color="#F9FAFB"
      header-text-color="#616D7C"
      :header-max-lines="2"
      :showPagination="false"
      :actionColumnWidth="80"
      height="60vh"
      max-height="60vh"
      actionLabel="Storage"
      :default-sort="{ prop: 'time', order: 'descending' }"
    >
      <template #select="{ row }">
        <CompRadio
          v-model="row.frontEnd_select" 
          label=""
          allow-uncheck
          @change="(val) => handleSelect(val, row)"
        />
      </template>
      <template #status="{ row }">
        <OnlineStatus radius="2px"
          :showPoint="false"
          upperCase
          onlineBlue
          :list="commStatusList"
          :commStatus="row.commStatus">
        </OnlineStatus>
      </template>
      <template #modelId="{ row }">
        {{ row.modelName }}
      </template>
    </CompTable>
    <template #footer>
      <div style="margin: 10px 20px;">
        <el-pagination
          background
          v-model:current-page="page.currentPage"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, ->, prev, pager, next, jumper"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
      <div style="display: flex; justify-content: center; width: 100%">
        <comp-button size="large" type="default" style="width: 120px;" @click="onCancel()">{{ Lang.btn.cancel }}</comp-button>
        <comp-button size="large" type="primary" style="width: 120px;" @click="onConfirmSelectDevice()">{{ confirmBtnText || Lang.btn.confirm }}</comp-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getItemPage } from '@/api/gateway/device';
import { mapGetters } from 'vuex';
import { getLanguage, Lang } from '@/lang/lang';
import CompRadio from '@/components/comp-radio/index.vue';
import OnlineStatus from '@/views/gatewayManage/comps/OnlineStatus';
import { getDictionary } from '@/api/system/dict';
import CompSearch from '@/components/comp-search/index.vue';
import CompTable from '@/components/comp-table/index.vue';

export default {
  name: 'SelectDevice',
  props: {
    selectedDevice: {
      type: Array,
      default() {
        return [];
      },
    },
    dimensionType: {
      type: String,
      default: ''
    },
    deptId: {
      type: String,
      default: ''
    },
    tooltipText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    confirmBtnText: {
      type: String,
      default: ''
    },
  },
  components: {
    CompRadio,
    OnlineStatus,
    CompSearch,
    CompTable
  },
  data() {
    return {
      selectAll: false,
      selectDeviceDialog: true,
      currentLangKey: this.language,
      tableKey: 0,
      form: {},
      commStatusList: [],
      selectionList: [],
      query: {},
      search: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      direction: 'rtl',
      scopeLoading: false,
      menu: true,
      data: [],
      column: [
        {
          label: '',
          prop: 'select',
          slotName: 'select',
          width: '50px',
          slot: true
        },
        {
          label: this.Lang.Title.dimensionDeviceName,
          prop: 'name',
          search: false,
          editDisplay: false,
          viewDisplay: false,
          addDisplay: false,
          oninput: (e) => {
            this.onLoad(this.page, this.search);
          },
          change: (e) => {
            if (!e.value) {
              this.onLoad(this.page, {});
            }
          },
        },
        {
          label: this.Lang.Title.dimensionGw,
          prop: 'deviceName',
          search: false,
        },
        {
          label: this.Lang.Title.dimensionGwGroup,
          prop: 'groupName',
          search: false,
        },
        {
          label: this.Lang.Title.dimensionDeviceSn,
          prop: 'sn',
          search: false,
          oninput: (e) => {
            this.onLoad(this.page, {sn: e.data});
          },
          change: (e) => {
            if (!e.value) {
              this.onLoad(this.page, {});
            }
          },
        },
        {
          label: this.Lang.Title.dimensionModel,
          prop: 'modelId',
          slotName: 'modelId',
          slot: true,
          search: false,
        },
        {
          label: this.Lang.Title.dimensionStatus,
          prop: 'status',
          search: false,
          slot: true,
          slotName: 'status',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['menuItem', 'permission', 'language']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    scopeIds() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.getCommStatusList()
  },
  mounted() {
    this.search.language = this.language; // 默认当前语言
    this.searchReset();
  },
  methods: {
    onConfirmSelectDevice() {
      this.$emit('onConfirmSelectDevice', this.selectionList);
      // this.selectDeviceDialog = false;
    },
    onCancel() {
      this.$emit('onCancel')
    },
    getCommStatusList() {
      getDictionary({code: 'commStatus'}).then(res => {
        const data = res.data.data;
        this.commStatusList = data;
      })
    },
    handleSelect(val, row) {
      this.data.forEach(item => {
        if (item.id != row.id) {
          item.frontEnd_select = false;
        }
      })
      if (val) {
        this.selectionList = [row]
      }
    },
    selectionClear() {
      this.selectionList = [];
    },
    getSelectedDevice() {
      const selectedDevice = this.selectionList;
      return selectedDevice;
    },
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.onLoad(this.page, params);
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.searchReset()
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.searchReset()
    },
    onLoad(page, params = {}) {
      this.scopeLoading = true;
      const values = {
        ...params,
      };
      if (this.dimensionType === 'AreaEnergy') {
      } else if (this.dimensionType === 'Environment') {
        values.iotProduct = 'environmental_sensor';
      } else if (this.dimensionType === 'Photovoltaic') {
        // 待产品提才过滤
      }
      if (this.deptId) {
        values.deptId = this.deptId;
      }
      getItemPage(page.currentPage, page.pageSize, Object.assign(values, this.query), this.currentLangKey).then(
        res => {
          const data = res.data.data;
          this.page.total = data.total;
          data.records.forEach(item => {
            item.frontEnd_select = false;
          })
          this.data = data.records;
          this.scopeLoading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>
